import React, { useEffect, useState } from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { t } from "../../../services/locale.service";

interface LoadingProps {
  message?: string;
}

const Loading: React.FC<LoadingProps> = ({ message}) => {
  const [translatedMessage, setTranslatedMessage] = useState<string>("");

  useEffect(() => {
    const fetchTranslation = async () => {
      const translation = message || (t("Loading"));  
      setTranslatedMessage(translation);  
    };

    fetchTranslation();  
  }, [message]);


  return (
    <div
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "green",
      }}
    >
      <AiOutlineLoading3Quarters
        style={{
          fontSize: "2rem",
          animation: "spin 1s linear infinite",
        }}
        color="green"
      />
      <p>{translatedMessage}</p>
      <style>
        {`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}
      </style>
    </div>
  );
};

export default Loading;
